// import { useState, useEffect } from 'react';
// import withAuth from '../../auth/WithAuth';
// import './transactions.scss';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import {
//   FaDollarSign,
//   FaChartLine,
//   FaSpinner,
//   FaSearch,
//   FaFileExport,
//   FaCheck,
//   FaTimes,
//   FaClock,
//   FaBan,
//   FaEye,
//   FaFilter,
//   FaSort,
//   FaProjectDiagram,
//   FaStore,
//   FaWallet,
// } from 'react-icons/fa';

// const TransactionsManagement = () => {
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [financialData, setFinancialData] = useState(null);
//   const [filters, setFilters] = useState({
//     type: 'all',
//     status: 'all',
//     dateRange: 'all',
//     search: '',
//   });
//   const [selectedTransactions, setSelectedTransactions] = useState([]);
//   const [sortConfig, setSortConfig] = useState({
//     key: 'created_at',
//     direction: 'desc',
//   });
//   const [showFilters, setShowFilters] = useState(false);

//   // Fetch transactions from API
//   const fetchTransactions = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('projects/admin/financials/');
//       setFinancialData(response.data);

//       // Use the transactions from API directly
//       if (response.data.transactions) {
//         setTransactions(response.data.transactions);
//       }
//     } catch (error) {
//       console.error('Error fetching transactions:', error);
//       toast.error('Failed to load transactions');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTransactions();
//   }, []);

//   // Filter transactions
//   const filteredTransactions = transactions.filter((transaction) => {
//     if (filters.type !== 'all' && transaction.type !== filters.type)
//       return false;
//     if (filters.status !== 'all' && transaction.status !== filters.status)
//       return false;
//     if (
//       filters.search &&
//       !transaction.id.toLowerCase().includes(filters.search.toLowerCase()) &&
//       !transaction.user_name
//         .toLowerCase()
//         .includes(filters.search.toLowerCase()) &&
//       !transaction.project_title
//         .toLowerCase()
//         .includes(filters.search.toLowerCase())
//     )
//       return false;

//     // Date range filtering
//     if (filters.dateRange !== 'all') {
//       const transactionDate = new Date(transaction.created_at);
//       const now = new Date();
//       let startDate = new Date();

//       switch (filters.dateRange) {
//         case 'today':
//           startDate.setHours(0, 0, 0, 0);
//           break;
//         case 'week':
//           startDate.setDate(now.getDate() - 7);
//           break;
//         case 'month':
//           startDate.setMonth(now.getMonth() - 1);
//           break;
//         default:
//           return true;
//       }

//       if (transactionDate < startDate) return false;
//     }

//     return true;
//   });

//   // Sort transactions
//   const sortedTransactions = [...filteredTransactions].sort((a, b) => {
//     const aVal = a[sortConfig.key];
//     const bVal = b[sortConfig.key];
//     if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
//     if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
//     return 0;
//   });

//   const handleSort = (key) => {
//     setSortConfig({
//       key,
//       direction:
//         sortConfig.key === key && sortConfig.direction === 'asc'
//           ? 'desc'
//           : 'asc',
//     });
//   };

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedTransactions(sortedTransactions.map((t) => t.id));
//     } else {
//       setSelectedTransactions([]);
//     }
//   };

//   const handleSelectTransaction = (id) => {
//     setSelectedTransactions((prev) =>
//       prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id],
//     );
//   };

//   const handleStatusUpdate = async (transactionId, newStatus) => {
//     try {
//       // API call to update status
//       // await serverUrlAuth.patch(`admin/transactions/${transactionId}/`, { status: newStatus });

//       setTransactions(
//         transactions.map((t) =>
//           t.id === transactionId ? { ...t, status: newStatus } : t,
//         ),
//       );
//       toast.success(`Transaction ${transactionId} updated to ${newStatus}`);
//     } catch (error) {
//       console.error('Error updating transaction:', error);
//       toast.error('Failed to update transaction');
//     }
//   };

//   const handleBulkAction = async (action) => {
//     if (selectedTransactions.length === 0) {
//       toast.warning('Please select transactions first');
//       return;
//     }

//     try {
//       // API call for bulk action
//       // await serverUrlAuth.post('admin/transactions/bulk/', { ids: selectedTransactions, action });

//       toast.success(
//         `${selectedTransactions.length} transactions ${action} successfully`,
//       );
//       setSelectedTransactions([]);
//       fetchTransactions();
//     } catch (error) {
//       console.error('Error performing bulk action:', error);
//       toast.error('Failed to perform bulk action');
//     }
//   };

//   const getStatusInfo = (status) => {
//     const info = {
//       completed: { color: '#10b981', icon: <FaCheck />, label: 'Completed' },
//       pending: { color: '#f59e0b', icon: <FaClock />, label: 'Pending' },
//       failed: { color: '#ef4444', icon: <FaTimes />, label: 'Failed' },
//       cancelled: { color: '#6b7280', icon: <FaBan />, label: 'Cancelled' },
//       success: { color: '#10b981', icon: <FaCheck />, label: 'Successful' },
//     };
//     return (
//       info[status] || { color: '#6b7280', icon: <FaTimes />, label: 'Unknown' }
//     );
//   };

//   const getTypeInfo = (type) => {
//     const info = {
//       payment: { color: '#3b82f6', icon: '💰', label: 'Payment' },
//       payout: { color: '#8b5cf6', icon: '💸', label: 'Payout' },
//       commission: { color: '#f59e0b', icon: '📊', label: 'Commission' },
//       refund: { color: '#ef4444', icon: '↩️', label: 'Refund' },
//     };
//     return info[type] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
//   };

//   const formatCurrency = (amount) => {
//     return `KSh ${(amount || 0).toLocaleString('en-KE', {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     })}`;
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="admin-transactions loading">
//           <div className="loading-container">
//             <FaSpinner className="spinner" />
//             <p>Loading transactions...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   const revenueSummary = financialData?.revenue_summary || {};
//   const customMetrics = financialData?.custom_payment_metrics || {};
//   const readyMadeMetrics = financialData?.ready_made_metrics || {};

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="admin-transactions">
//         <div className="page-header">
//           <div className="header-content">
//             <div className="header-text">
//               <h1>💰 Financial Transactions</h1>
//               <p>Manage payments, commissions, and platform revenue</p>
//             </div>
//             <div className="header-actions">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handleBulkAction('export')}
//                 disabled={selectedTransactions.length === 0}
//               >
//                 <FaFileExport /> Export Selected
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Revenue Summary Cards */}
//         <div className="financial-overview">
//           <div className="finance-card total-revenue">
//             <div className="finance-content">
//               <div className="finance-icon">
//                 <FaDollarSign />
//               </div>
//               <div className="finance-info">
//                 <h3>Total Revenue</h3>
//                 <p className="finance-value">
//                   {formatCurrency(revenueSummary.platform?.total || 0)}
//                 </p>
//                 <span className="finance-change positive">
//                   <FaChartLine /> {revenueSummary.platform?.growth || 0}% this
//                   month
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="finance-card custom-revenue">
//             <div className="finance-content">
//               <div className="finance-icon">
//                 <FaProjectDiagram />
//               </div>
//               <div className="finance-info">
//                 <h3>Custom Projects</h3>
//                 <p className="finance-value">
//                   {formatCurrency(revenueSummary.custom_projects?.total || 0)}
//                 </p>
//                 <span className="finance-change positive">
//                   {revenueSummary.custom_projects?.growth || 0}% this month
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="finance-card ready-revenue">
//             <div className="finance-content">
//               <div className="finance-icon">
//                 <FaStore />
//               </div>
//               <div className="finance-info">
//                 <h3>Ready-Made</h3>
//                 <p className="finance-value">
//                   {formatCurrency(revenueSummary.ready_made?.total || 0)}
//                 </p>
//                 <span className="finance-change positive">
//                   {revenueSummary.ready_made?.growth || 0}% this month
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="finance-card success-rate">
//             <div className="finance-content">
//               <div className="finance-icon">
//                 <FaWallet />
//               </div>
//               <div className="finance-info">
//                 <h3>Success Rate</h3>
//                 <p className="finance-value">
//                   {transactions.length > 0
//                     ? (
//                         (transactions.filter(
//                           (t) =>
//                             t.status === 'completed' || t.status === 'success',
//                         ).length /
//                           transactions.length) *
//                         100
//                       ).toFixed(1)
//                     : 0}
//                   %
//                 </p>
//                 <span className="finance-change neutral">
//                   {transactions.filter((t) => t.status === 'failed').length}{' '}
//                   failed
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Additional Metrics */}
//         <div className="metrics-row">
//           <div className="metric-card">
//             <span className="metric-label">Custom Payments</span>
//             <span className="metric-value">
//               {customMetrics.successful || 0}
//             </span>
//             <span className="metric-sub">
//               {customMetrics.pending || 0} pending
//             </span>
//           </div>
//           <div className="metric-card">
//             <span className="metric-label">Ready-Made Orders</span>
//             <span className="metric-value">{readyMadeMetrics.paid || 0}</span>
//             <span className="metric-sub">
//               {readyMadeMetrics.pending || 0} pending
//             </span>
//           </div>
//           <div className="metric-card">
//             <span className="metric-label">Deposit Payments</span>
//             <span className="metric-value">
//               {customMetrics.deposit_payments || 0}
//             </span>
//             <span className="metric-sub">
//               {customMetrics.balance_payments || 0} balance
//             </span>
//           </div>
//           <div className="metric-card">
//             <span className="metric-label">Avg Payment</span>
//             <span className="metric-value">
//               {formatCurrency(customMetrics.average_amount || 0)}
//             </span>
//             <span className="metric-sub">
//               Avg Order:{' '}
//               {formatCurrency(readyMadeMetrics.average_order_value || 0)}
//             </span>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="filters-section">
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch className="search-icon" />
//               <input
//                 type="text"
//                 placeholder="Search by user name"
//                 value={filters.search}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, search: e.target.value }))
//                 }
//               />
//             </div>

//             <button
//               className="filter-toggle"
//               onClick={() => setShowFilters(!showFilters)}
//             >
//               <FaFilter /> Filters
//             </button>

//             <div className={`filter-group ${showFilters ? 'show' : ''}`}>
//               <select
//                 value={filters.type}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, type: e.target.value }))
//                 }
//               >
//                 <option value="all">All Types</option>
//                 <option value="payment">Payments</option>
//                 <option value="payout">Payouts</option>
//                 <option value="commission">Commissions</option>
//                 <option value="refund">Refunds</option>
//               </select>

//               <select
//                 value={filters.status}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, status: e.target.value }))
//                 }
//               >
//                 <option value="all">All Status</option>
//                 <option value="completed">Completed</option>
//                 <option value="pending">Pending</option>
//                 <option value="failed">Failed</option>
//                 <option value="cancelled">Cancelled</option>
//                 <option value="success">Successful</option>
//               </select>

//               <select
//                 value={filters.dateRange}
//                 onChange={(e) =>
//                   setFilters((prev) => ({ ...prev, dateRange: e.target.value }))
//                 }
//               >
//                 <option value="all">All Time</option>
//                 <option value="today">Today</option>
//                 <option value="week">This Week</option>
//                 <option value="month">This Month</option>
//               </select>

//               <button
//                 className="btn btn-secondary"
//                 onClick={() =>
//                   setFilters({
//                     type: 'all',
//                     status: 'all',
//                     dateRange: 'all',
//                     search: '',
//                   })
//                 }
//               >
//                 Clear All
//               </button>
//             </div>

//             <div className="results-count">
//               {sortedTransactions.length} of {transactions.length} transactions
//             </div>
//           </div>
//         </div>

//         {/* Transactions Table */}
//         <div className="transactions-section">
//           <div className="section-header">
//             <h3>Transaction History</h3>
//             <div className="section-actions">
//               <select
//                 className="bulk-actions"
//                 onChange={(e) => handleBulkAction(e.target.value)}
//                 defaultValue=""
//                 disabled={selectedTransactions.length === 0}
//               >
//                 <option value="" disabled>
//                   Bulk Actions ({selectedTransactions.length})
//                 </option>
//                 <option value="process">Process Pending</option>
//                 <option value="retry">Retry Failed</option>
//                 <option value="export">Export Selected</option>
//               </select>
//             </div>
//           </div>

//           <div className="table-container">
//             <table className="transactions-table">
//               <thead>
//                 <tr>
//                   <th>
//                     <input
//                       type="checkbox"
//                       className="select-all"
//                       checked={
//                         selectedTransactions.length ===
//                           sortedTransactions.length &&
//                         sortedTransactions.length > 0
//                       }
//                       onChange={handleSelectAll}
//                     />
//                   </th>
//                   <th onClick={() => handleSort('id')} className="sortable">
//                     Transaction <FaSort />
//                   </th>
//                   <th onClick={() => handleSort('type')} className="sortable">
//                     Type <FaSort />
//                   </th>
//                   <th>User & Project</th>
//                   <th onClick={() => handleSort('amount')} className="sortable">
//                     Amount <FaSort />
//                   </th>
//                   <th onClick={() => handleSort('status')} className="sortable">
//                     Status <FaSort />
//                   </th>
//                   <th
//                     onClick={() => handleSort('created_at')}
//                     className="sortable"
//                   >
//                     Date & Method <FaSort />
//                   </th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {sortedTransactions.map((transaction) => {
//                   const statusInfo = getStatusInfo(transaction.status);
//                   const typeInfo = getTypeInfo(transaction.type);

//                   return (
//                     <tr key={transaction.id} className={transaction.status}>
//                       <td>
//                         <input
//                           type="checkbox"
//                           className="transaction-select"
//                           checked={selectedTransactions.includes(
//                             transaction.id,
//                           )}
//                           onChange={() =>
//                             handleSelectTransaction(transaction.id)
//                           }
//                         />
//                       </td>
//                       <td>
//                         <div className="transaction-info">
//                           <div className="transaction-id">{transaction.id}</div>
//                           <div className="transaction-description">
//                             {transaction.description}
//                           </div>
//                           {transaction.reference && (
//                             <div className="transaction-reference">
//                               Ref: {transaction.reference}
//                             </div>
//                           )}
//                           {transaction.payment_type && (
//                             <div className="transaction-payment-type">
//                               Type: {transaction.payment_type}
//                             </div>
//                           )}
//                         </div>
//                       </td>
//                       <td>
//                         <span className={`type-badge ${transaction.type}`}>
//                           <span className="type-icon">{typeInfo.icon}</span>
//                           {typeInfo.label}
//                         </span>
//                       </td>
//                       <td>
//                         <div className="user-project-info">
//                           <div className="user-avatar">
//                             {transaction.user_name?.charAt(0) || 'U'}
//                           </div>
//                           <div className="user-details">
//                             <strong>{transaction.user_name}</strong>
//                             <span>{transaction.user_email}</span>
//                             <span className="user-type">
//                               {transaction.user_type}
//                             </span>
//                           </div>
//                           <div className="project-title">
//                             {transaction.project_title}
//                             {transaction.project_id && (
//                               <span className="project-id">
//                                 ID: {transaction.project_id}
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </td>
//                       <td>
//                         <div className="amount-details">
//                           <div className="amount-main">
//                             {formatCurrency(transaction.amount)}
//                           </div>
//                           {transaction.fee > 0 && (
//                             <div className="amount-fee">
//                               Fee: {formatCurrency(transaction.fee)}
//                             </div>
//                           )}
//                           <div className="amount-net">
//                             Net: {formatCurrency(transaction.net_amount)}
//                           </div>
//                         </div>
//                       </td>
//                       <td>
//                         <span
//                           className={`status-badge ${transaction.status}`}
//                           style={{ backgroundColor: statusInfo.color }}
//                         >
//                           <span className="status-icon">{statusInfo.icon}</span>
//                           {statusInfo.label}
//                         </span>
//                         {transaction.failure_reason && (
//                           <div className="failure-reason">
//                             {transaction.failure_reason}
//                           </div>
//                         )}
//                       </td>
//                       <td>
//                         <div className="date-method-info">
//                           <div className="transaction-date">
//                             {new Date(
//                               transaction.created_at,
//                             ).toLocaleDateString()}
//                           </div>
//                           <div className="transaction-time">
//                             {new Date(
//                               transaction.created_at,
//                             ).toLocaleTimeString()}
//                           </div>
//                           <div className="payment-method">
//                             {transaction.payment_method}
//                           </div>
//                           {transaction.completed_at && (
//                             <div className="completed-date">
//                               Completed:{' '}
//                               {new Date(
//                                 transaction.completed_at,
//                               ).toLocaleDateString()}
//                             </div>
//                           )}
//                         </div>
//                       </td>
//                       <td>
//                         <div className="action-buttons">
//                           <button
//                             className="btn btn-sm btn-outline"
//                             title="View Details"
//                             onClick={() =>
//                               toast.info(
//                                 `Transaction ${transaction.id} details`,
//                               )
//                             }
//                           >
//                             <FaEye />
//                           </button>
//                           <select
//                             value={transaction.status}
//                             onChange={(e) =>
//                               handleStatusUpdate(transaction.id, e.target.value)
//                             }
//                             className="status-select"
//                           >
//                             <option value="pending">Pending</option>
//                             <option value="completed">Completed</option>
//                             <option value="failed">Failed</option>
//                             <option value="cancelled">Cancelled</option>
//                             <option value="success">Successful</option>
//                           </select>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>

//             {sortedTransactions.length === 0 && (
//               <div className="empty-state">
//                 <div className="empty-icon">💰</div>
//                 <h3>No transactions found</h3>
//                 <p>
//                   No transactions match your current filter criteria. Try
//                   adjusting your search or filters.
//                 </p>
//                 <button
//                   className="btn btn-primary"
//                   onClick={() =>
//                     setFilters({
//                       type: 'all',
//                       status: 'all',
//                       dateRange: 'all',
//                       search: '',
//                     })
//                   }
//                 >
//                   Clear All Filters
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="section-footer">
//           <div className="footer-info">
//             Showing {sortedTransactions.length} of {transactions.length}{' '}
//             transactions
//           </div>
//           <div className="pagination">
//             <button className="page-btn" disabled>
//               ← Previous
//             </button>
//             <span className="page-info">Page 1 of 1</span>
//             <button className="page-btn" disabled>
//               Next →
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default withAuth(TransactionsManagement, 'admin');


// src/pages/admin/TransactionsManagement.jsx
import { useState, useEffect } from 'react';
import withAuth from '../../auth/WithAuth';
import './transactions.scss';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaDollarSign,
  FaChartLine,
  FaSpinner,
  FaSearch,
  FaFileExport,
  FaCheck,
  FaTimes,
  FaClock,
  FaBan,
  FaEye,
  FaFilter,
  FaSort,
  FaProjectDiagram,
  FaStore,
  FaWallet,
  FaSyncAlt,
} from 'react-icons/fa';
import Sidebar from '../../../components/layout/Sidebar';

const TransactionsManagement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [financialData, setFinancialData] = useState(null);
  const [filters, setFilters] = useState({
    type: 'all',
    status: 'all',
    dateRange: 'all',
    search: '',
  });
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: 'created_at',
    direction: 'desc',
  });
  const [showFilters, setShowFilters] = useState(false);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('projects/admin/financials/');
      setFinancialData(response.data);

      if (response.data.transactions) {
        setTransactions(response.data.transactions);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
      toast.error('Failed to load transactions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const filteredTransactions = transactions.filter((transaction) => {
    if (filters.type !== 'all' && transaction.type !== filters.type)
      return false;
    if (filters.status !== 'all' && transaction.status !== filters.status)
      return false;
    if (
      filters.search &&
      !transaction.id.toLowerCase().includes(filters.search.toLowerCase()) &&
      !transaction.user_name
        .toLowerCase()
        .includes(filters.search.toLowerCase()) &&
      !transaction.project_title
        .toLowerCase()
        .includes(filters.search.toLowerCase())
    )
      return false;

    if (filters.dateRange !== 'all') {
      const transactionDate = new Date(transaction.created_at);
      const now = new Date();
      let startDate = new Date();

      switch (filters.dateRange) {
        case 'today':
          startDate.setHours(0, 0, 0, 0);
          break;
        case 'week':
          startDate.setDate(now.getDate() - 7);
          break;
        case 'month':
          startDate.setMonth(now.getMonth() - 1);
          break;
        default:
          return true;
      }

      if (transactionDate < startDate) return false;
    }

    return true;
  });

  const sortedTransactions = [...filteredTransactions].sort((a, b) => {
    const aVal = a[sortConfig.key];
    const bVal = b[sortConfig.key];
    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === 'asc'
          ? 'desc'
          : 'asc',
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedTransactions(sortedTransactions.map((t) => t.id));
    } else {
      setSelectedTransactions([]);
    }
  };

  const handleSelectTransaction = (id) => {
    setSelectedTransactions((prev) =>
      prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id],
    );
  };

  const handleStatusUpdate = async (transactionId, newStatus) => {
    try {
      setTransactions(
        transactions.map((t) =>
          t.id === transactionId ? { ...t, status: newStatus } : t,
        ),
      );
      toast.success(`Transaction ${transactionId} updated to ${newStatus}`);
    } catch (error) {
      console.error('Error updating transaction:', error);
      toast.error('Failed to update transaction');
    }
  };

  const handleBulkAction = async (action) => {
    if (selectedTransactions.length === 0) {
      toast.warning('Please select transactions first');
      return;
    }

    try {
      toast.success(
        `${selectedTransactions.length} transactions ${action} successfully`,
      );
      setSelectedTransactions([]);
      fetchTransactions();
    } catch (error) {
      console.error('Error performing bulk action:', error);
      toast.error('Failed to perform bulk action');
    }
  };

  const getStatusInfo = (status) => {
    const info = {
      completed: { color: '#6b8e23', icon: <FaCheck />, label: 'Completed' },
      pending: { color: '#b8860b', icon: <FaClock />, label: 'Pending' },
      failed: { color: '#8b2e1a', icon: <FaTimes />, label: 'Failed' },
      cancelled: { color: '#8a7a6a', icon: <FaBan />, label: 'Cancelled' },
      success: { color: '#6b8e23', icon: <FaCheck />, label: 'Successful' },
    };
    return (
      info[status] || { color: '#8a7a6a', icon: <FaTimes />, label: 'Unknown' }
    );
  };

  const getTypeInfo = (type) => {
    const info = {
      payment: { color: '#673200', icon: '💰', label: 'Payment' },
      payout: { color: '#4a2400', icon: '💸', label: 'Payout' },
      commission: { color: '#8a5018', icon: '📊', label: 'Commission' },
      refund: { color: '#8b2e1a', icon: '↩️', label: 'Refund' },
    };
    return info[type] || { color: '#8a7a6a', icon: '❓', label: 'Unknown' };
  };

  const formatCurrency = (amount) => {
    return `KSh ${(amount || 0).toLocaleString('en-KE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="admin-transactions loading">
          <div className="loading-container">
            <FaSpinner className="spinner" />
            <p>Loading transactions…</p>
          </div>
        </div>
      </>
    );
  }

  const revenueSummary = financialData?.revenue_summary || {};
  const customMetrics = financialData?.custom_payment_metrics || {};
  const readyMadeMetrics = financialData?.ready_made_metrics || {};

  const financeCards = [
    {
      key: 'total-revenue',
      icon: <FaDollarSign />,
      label: 'Total Revenue',
      value: formatCurrency(revenueSummary.platform?.total || 0),
      change: `+${revenueSummary.platform?.growth || 0}% this month`,
      changeType: 'positive',
      changeIcon: <FaChartLine />,
    },
    {
      key: 'custom-revenue',
      icon: <FaProjectDiagram />,
      label: 'Custom Projects',
      value: formatCurrency(revenueSummary.custom_projects?.total || 0),
      change: `+${revenueSummary.custom_projects?.growth || 0}% this month`,
      changeType: 'positive',
    },
    {
      key: 'ready-revenue',
      icon: <FaStore />,
      label: 'Ready-Made',
      value: formatCurrency(revenueSummary.ready_made?.total || 0),
      change: `+${revenueSummary.ready_made?.growth || 0}% this month`,
      changeType: 'positive',
    },
    {
      key: 'success-rate',
      icon: <FaWallet />,
      label: 'Success Rate',
      value: `${
        transactions.length > 0
          ? (
              (transactions.filter(
                (t) => t.status === 'completed' || t.status === 'success',
              ).length /
                transactions.length) *
              100
            ).toFixed(1)
          : 0
      }%`,
      change: `${transactions.filter((t) => t.status === 'failed').length} failed`,
      changeType: 'neutral',
    },
  ];

  const metricCards = [
    {
      label: 'Custom Payments',
      value: customMetrics.successful || 0,
      sub: `${customMetrics.pending || 0} pending`,
    },
    {
      label: 'Ready-Made Orders',
      value: readyMadeMetrics.paid || 0,
      sub: `${readyMadeMetrics.pending || 0} pending`,
    },
    {
      label: 'Deposit Payments',
      value: customMetrics.deposit_payments || 0,
      sub: `${customMetrics.balance_payments || 0} balance`,
    },
    {
      label: 'Avg Payment',
      value: formatCurrency(customMetrics.average_amount || 0),
      sub: `Avg Order: ${formatCurrency(readyMadeMetrics.average_order_value || 0)}`,
    },
  ];

  return (
    <>
      <Sidebar />
      <div className="admin-transactions">
        {/* ============ PAGE HEADER ============ */}
        <div className="page-header">
          <div className="header-content">
            <div className="header-text">
              <span className="eyebrow">Admin · Finance</span>
              <h1>Financial Transactions</h1>
              <p>Manage payments, commissions, and platform revenue</p>
            </div>
            <div className="header-actions">
              <button
                className="btn btn-primary"
                onClick={() => handleBulkAction('export')}
                disabled={selectedTransactions.length === 0}
              >
                <FaFileExport /> Export Selected
              </button>
            </div>
          </div>
        </div>

        {/* ============ FINANCE OVERVIEW ============ */}
        <div className="financial-overview">
          {financeCards.map((card) => (
            <div key={card.key} className={`finance-card ${card.key}`}>
              <div className="finance-content">
                <div className="finance-icon">{card.icon}</div>
                <div className="finance-info">
                  <h3>{card.label}</h3>
                  <p className="finance-value">{card.value}</p>
                  <span className={`finance-change ${card.changeType}`}>
                    {card.changeIcon} {card.change}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ============ METRICS ROW ============ */}
        <div className="metrics-row">
          {metricCards.map((m, i) => (
            <div key={i} className="metric-card">
              <span className="metric-label">{m.label}</span>
              <span className="metric-value">{m.value}</span>
              <span className="metric-sub">{m.sub}</span>
            </div>
          ))}
        </div>

        {/* ============ FILTERS ============ */}
        <div className="filters-section">
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by user name"
                value={filters.search}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </div>

            <button
              className="filter-toggle"
              onClick={() => setShowFilters(!showFilters)}
            >
              <FaFilter /> Filters
            </button>

            <div className={`filter-group ${showFilters ? 'show' : ''}`}>
              <select
                value={filters.type}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, type: e.target.value }))
                }
              >
                <option value="all">All Types</option>
                <option value="payment">Payments</option>
                <option value="payout">Payouts</option>
                <option value="commission">Commissions</option>
                <option value="refund">Refunds</option>
              </select>

              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="all">All Status</option>
                <option value="completed">Completed</option>
                <option value="pending">Pending</option>
                <option value="failed">Failed</option>
                <option value="cancelled">Cancelled</option>
                <option value="success">Successful</option>
              </select>

              <select
                value={filters.dateRange}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, dateRange: e.target.value }))
                }
              >
                <option value="all">All Time</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>

              <button
                className="btn-secondary"
                onClick={() =>
                  setFilters({
                    type: 'all',
                    status: 'all',
                    dateRange: 'all',
                    search: '',
                  })
                }
              >
                Clear All
              </button>
            </div>

            <div className="results-count">
              {sortedTransactions.length} of {transactions.length} transactions
            </div>
          </div>
        </div>

        {/* ============ TRANSACTIONS TABLE ============ */}
        <div className="transactions-section">
          <div className="section-header">
            <h3>Transaction History</h3>
            <div className="section-actions">
              <select
                className="bulk-actions"
                onChange={(e) => handleBulkAction(e.target.value)}
                defaultValue=""
                disabled={selectedTransactions.length === 0}
              >
                <option value="" disabled>
                  Bulk Actions ({selectedTransactions.length})
                </option>
                <option value="process">Process Pending</option>
                <option value="retry">Retry Failed</option>
                <option value="export">Export Selected</option>
              </select>
            </div>
          </div>

          <div className="table-container">
            <table className="transactions-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="select-all"
                      checked={
                        selectedTransactions.length ===
                          sortedTransactions.length &&
                        sortedTransactions.length > 0
                      }
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onClick={() => handleSort('id')} className="sortable">
                    Transaction <FaSort />
                  </th>
                  <th onClick={() => handleSort('type')} className="sortable">
                    Type <FaSort />
                  </th>
                  <th>User &amp; Project</th>
                  <th onClick={() => handleSort('amount')} className="sortable">
                    Amount <FaSort />
                  </th>
                  <th onClick={() => handleSort('status')} className="sortable">
                    Status <FaSort />
                  </th>
                  <th
                    onClick={() => handleSort('created_at')}
                    className="sortable"
                  >
                    Date &amp; Method <FaSort />
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedTransactions.map((transaction) => {
                  const statusInfo = getStatusInfo(transaction.status);
                  const typeInfo = getTypeInfo(transaction.type);

                  return (
                    <tr key={transaction.id} className={transaction.status}>
                      <td>
                        <input
                          type="checkbox"
                          className="transaction-select"
                          checked={selectedTransactions.includes(
                            transaction.id,
                          )}
                          onChange={() =>
                            handleSelectTransaction(transaction.id)
                          }
                        />
                      </td>
                      <td>
                        <div className="transaction-info">
                          <div className="transaction-id">{transaction.id}</div>
                          <div className="transaction-description">
                            {transaction.description}
                          </div>
                          {transaction.reference && (
                            <div className="transaction-reference">
                              Ref: {transaction.reference}
                            </div>
                          )}
                          {transaction.payment_type && (
                            <div className="transaction-payment-type">
                              Type: {transaction.payment_type}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <span className={`type-badge ${transaction.type}`}>
                          <span className="type-icon">{typeInfo.icon}</span>
                          {typeInfo.label}
                        </span>
                      </td>
                      <td>
                        <div className="user-project-info">
                          <div className="user-avatar">
                            {transaction.user_name?.charAt(0) || 'U'}
                          </div>
                          <div className="user-details">
                            <strong>{transaction.user_name}</strong>
                            <span>{transaction.user_email}</span>
                            <span className="user-type">
                              {transaction.user_type}
                            </span>
                          </div>
                          <div className="project-title">
                            {transaction.project_title}
                            {transaction.project_id && (
                              <span className="project-id">
                                ID: {transaction.project_id}
                              </span>
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="amount-details">
                          <div className="amount-main">
                            {formatCurrency(transaction.amount)}
                          </div>
                          {transaction.fee > 0 && (
                            <div className="amount-fee">
                              Fee: {formatCurrency(transaction.fee)}
                            </div>
                          )}
                          <div className="amount-net">
                            Net: {formatCurrency(transaction.net_amount)}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span
                          className={`status-badge ${transaction.status}`}
                          style={{ backgroundColor: statusInfo.color }}
                        >
                          <span className="status-icon">{statusInfo.icon}</span>
                          {statusInfo.label}
                        </span>
                        {transaction.failure_reason && (
                          <div className="failure-reason">
                            {transaction.failure_reason}
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="date-method-info">
                          <div className="transaction-date">
                            {new Date(
                              transaction.created_at,
                            ).toLocaleDateString()}
                          </div>
                          <div className="transaction-time">
                            {new Date(
                              transaction.created_at,
                            ).toLocaleTimeString()}
                          </div>
                          <div className="payment-method">
                            {transaction.payment_method}
                          </div>
                          {transaction.completed_at && (
                            <div className="completed-date">
                              Completed:{' '}
                              {new Date(
                                transaction.completed_at,
                              ).toLocaleDateString()}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="btn btn-sm btn-outline"
                            title="View Details"
                            onClick={() =>
                              toast.info(
                                `Transaction ${transaction.id} details`,
                              )
                            }
                          >
                            <FaEye />
                          </button>
                          <select
                            value={transaction.status}
                            onChange={(e) =>
                              handleStatusUpdate(transaction.id, e.target.value)
                            }
                            className="status-select"
                          >
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                            <option value="failed">Failed</option>
                            <option value="cancelled">Cancelled</option>
                            <option value="success">Successful</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {sortedTransactions.length === 0 && (
              <div className="empty-state">
                <div className="empty-icon">
                  <FaDollarSign />
                </div>
                <h3>No transactions found</h3>
                <p>
                  No transactions match your current filter criteria. Try
                  adjusting your search or filters.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    setFilters({
                      type: 'all',
                      status: 'all',
                      dateRange: 'all',
                      search: '',
                    })
                  }
                >
                  Clear All Filters
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ============ FOOTER ============ */}
        <div className="section-footer">
          <div className="footer-info">
            Showing {sortedTransactions.length} of {transactions.length}{' '}
            transactions
          </div>
          <div className="pagination">
            <button className="page-btn" disabled>
              ← Previous
            </button>
            <span className="page-info">Page 1 of 1</span>
            <button className="page-btn" disabled>
              Next →
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuth(TransactionsManagement, 'admin');